<div class="modal-content">
    <div class="modal-header">
        <div class="modal-title h4" id="example-modal-sizes-title-lg" style="color: white;">

            {{"MENU.ChooseFromPackage" | translate}}
        </div>
    </div>
    <div class="pricing-area ptb-100">
        <div class="container">
            <div class="pricing">
                <div class="plan" *ngFor="let item of models">
                    <!-- <div class="plan popular"> -->
                    <span>{{item?.name}}</span>
                    <div class="price">{{item.price}}$/{{item.creditPoints}}</div>
                    <div [innerHTML]="item.details"></div>

                    <button type="submit" (click)="selectPackage(item.referenceId)">
                        <span *ngIf="isSaving" class="spinner-border spinner-border-sm" role="status"
                            aria-hidden="true"></span>

                        {{item.buttonText}}
                    </button>
                </div>
            </div>
        </div>
        <div class="modal-footer">
            <button style="border-color:rgb(60, 56, 113) !important ; background-color: #B24EFF; color: white;" type="button"
                class="btn btn-light btn-elevate mr-2" (click)="modal.dismiss()">
                {{ "MENU.Cancel" | translate
                }}
            </button>
        </div>
    </div>
</div>